import {
  Button,Menu,MenuItem,Paper,Stack,
  Table,TableBody,TableCell,TableContainer,TableHead,TableRow
} from "@mui/material";
import React, {useState} from "react";
import {useNavigate} from "react-router-dom";
import {MoreVert} from "@mui/icons-material";
import {styled} from "@mui/material/styles";
import {postCall} from "../../../Api/axios";
import Tooltip from '@mui/material/Tooltip';
import {toast} from 'react-toastify';
import TablePagination from "@mui/material/TablePagination";

const StyledTableCell = styled(TableCell)({
  "&.MuiTableCell-root": {
    fontWeight: "bold",
  },
});

const ThreeDotsMenu = (props) => {
  const {row, isOrgAdmin, getSuperAdmins, getOrgAdmins, view} = props;
  const [anchorEl, setAnchorEl] = useState(null);
  const navigate = useNavigate();

  const openActionMenu = (e) => {
    e.stopPropagation();
    setAnchorEl(e.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const action = async (e, action) => {
    e.stopPropagation();
    try {
      switch (action) {
        case "enable":
          await postCall(`/api/v2/dashboard/enableDisableUser`, {userId: row?._id, enabled: 'yes'});
          break;
        case "disable":
          await postCall(`/api/v2/dashboard/enableDisableUser`, {userId: row?._id, enabled: 'no'});
          break;
        default:
          break;
      }
      setAnchorEl(null);
      if (view === "superAdmin") {
        getSuperAdmins();
      } else {
        getOrgAdmins();
      }
    } catch (error) {
      toast.error(error.message);
    }
  };

  return (
    <div>
      <Tooltip title="Action">
        <Button
          id="user-action-menu-button"
          aria-controls={Boolean(anchorEl) ? "user-action-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={Boolean(anchorEl) ? "true" : undefined}
          onClick={openActionMenu}
          sx={{width: 30}}
        >
          <MoreVert/>
        </Button>
      </Tooltip>
      <Menu
        id="user-action-menu"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        MenuListProps={{
          onMouseLeave: handleClose,
          "aria-labelledby": "user-action-menu-button",
        }}
      >
        <MenuItem onClick={(e) => action(e, "enable")}>Mark as Active</MenuItem>
        <MenuItem onClick={(e) => action(e, "disable")}>
          Mark as Inactive
        </MenuItem>
      </Menu>
    </div>
  );
};

const UserTable = (props) => {
  const {
    getOrgAdmins,
    getSuperAdmins,
    columns,
    data,
    isOrgAdmin,
    page,
    rowsPerPage,
    totalRecords,
    handlePageChange,
    handleRowsPerPageChange,
    view,
  } = props;

  const onPageChange = (event, newPage) => {
    handlePageChange(newPage);
  };

  const onRowsPerPageChange = (event) => {
    handleRowsPerPageChange(parseInt(event.target.value, 10));
    handlePageChange(0);
  };

  return (
    <Paper sx={{width: "100%", overflow: "hidden"}}>
      <TableContainer>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            {columns.map((column) => (
              <StyledTableCell
                key={column.id}
                align={column.align}
                style={{
                  minWidth: column.minWidth,
                  backgroundColor: "#4B92E7",
                  color: "#fff",
                }}
              >
                {column.label}
              </StyledTableCell>
            ))}
          </TableHead>
          <TableBody>
            {data.length > 0 ?
              data.map((row, index) => {
                return (
                  <TableRow
                    // style={{ cursor: isProvider ? "pointer" : "default" }}
                    hover
                    tabIndex={-1}
                    key={index}
                  >
                    {columns.map((column) => {
                      const value = row[column.id];
                      if (column.id == "Action") {
                        const user_id = localStorage.getItem("user_id");
                        if (props.isOrgAdmin) {
                          return (
                            <TableCell key={column.id} align={"left"}>
                              <ThreeDotsMenu
                                view={view}
                                row={row}
                                isOrgAdmin={isOrgAdmin}
                                getSuperAdmins={getSuperAdmins}
                                getOrgAdmins={getOrgAdmins}
                              />
                            </TableCell>
                          );
                        } else {
                          if (user_id === row._id) {
                            return <></>;
                          } else {
                            return (
                              <TableCell key={column.id} align={"left"}>
                                <ThreeDotsMenu
                                  view={view}
                                  row={row}
                                  isOrgAdmin={isOrgAdmin}
                                  getSuperAdmins={getSuperAdmins}
                                  getOrgAdmins={getOrgAdmins}
                                />
                              </TableCell>
                            );
                          }
                        }
                      } else if (column.id == "status") {
                        return (
                          <TableCell key={column.id} align={column.align}>
                            <Stack direction="row" spacing={2}>
                              <span>{value}</span>
                            </Stack>
                          </TableCell>
                        );
                      } else if (column.id == "organisationName") {
                        return (
                          <TableCell key={column.id} align={column.align}>
                            {row?.organisation?.name}
                          </TableCell>
                        );
                      }
                      return (
                        <TableCell key={column.id} align={column.align}>
                          {value}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                );
              }) : (
                <TableRow>
                  <TableCell colSpan={props.columns.length + 2} align="center">
                    <lable className="text-sm">
                      No data to display
                    </lable>
                  </TableCell>
                </TableRow>
              )}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[10, 25, 100]}
        component="div"
        count={totalRecords}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={onPageChange}
        onRowsPerPageChange={onRowsPerPageChange}
      />
    </Paper>
  );
};

export default UserTable;
